import React from 'react'
import { bool, string, oneOfType } from 'prop-types'
import { connect } from 'react-redux'
import { Button } from '@livechat/design-system-react-components'

import {
  canInstallApplications,
  canBuy,
  getCartId,
  isResellerLicense,
  getCurrentInvalidSubscriptionForCart,
  getInvalidSubscriptionsForCart,
  hasCard,
  isSubscriptionFetched,
  isCartInitialized,
  isUserInitialized,
} from '@/store/selectors'
import { getProductSubscriptionPath } from '@/utils/products'
import { activeProduct } from '@/utils'
import GoToSubscriptionButton from './GoToSubscription'
import GoToCheckoutButton from './GoToCheckout'

const CheckoutButton = ({
  size = 'large',
  kind = 'primary',
  fullWidth,
  disabled,
  cartId,
  isReseller,
  currentInvalidSubscription,
  isAdminWithoutCreditCard,
  isLoading,
}) => {
  const buttonProps = { kind, size, fullWidth }

  if (isLoading) {
    return <Button {...buttonProps} loading />
  } else if (isReseller) {
    return (
      <GoToSubscriptionButton
        buttonProps={buttonProps}
        trackEvent="subscribeFromMarketplaceForResellers"
        path={process.env.GATSBY_PRODUCT_SUBSCRIPTION_PATH}
        directlyToSubscription
      />
    )
  } else if (isAdminWithoutCreditCard) {
    const invalidSubscription = currentInvalidSubscription || activeProduct
    const subscriptionPath = `${getProductSubscriptionPath(
      invalidSubscription
    )}/pick-${invalidSubscription}-plan`

    return (
      <GoToSubscriptionButton
        buttonProps={buttonProps}
        trackEvent="subscribeFromMarketplace"
        path={subscriptionPath}
        product={invalidSubscription}
      />
    )
  }

  return (
    <GoToCheckoutButton cartId={cartId} {...buttonProps} disabled={disabled} />
  )
}

const mapStateToProps = (state) => {
  const cartId = getCartId(state)
  const canUserBuy = canBuy(state)
  const canUserInstallApplications = canInstallApplications(state)
  const isReseller = isResellerLicense(state)
  const hasActiveProductCard = hasCard(state, activeProduct)
  const invalidCartSubscriptions = getInvalidSubscriptionsForCart(state)
  const hasValidSubscriptions =
    hasActiveProductCard && !invalidCartSubscriptions.length
  const currentInvalidSubscription = getCurrentInvalidSubscriptionForCart(state)
  const isAdminWithoutCreditCard =
    canUserInstallApplications && canUserBuy && !hasValidSubscriptions

  const isLoading =
    !isCartInitialized(state) ||
    !isUserInitialized(state) ||
    !isSubscriptionFetched(state)

  return {
    cartId,
    isReseller,
    isAdminWithoutCreditCard,
    currentInvalidSubscription,
    isLoading,
  }
}

CheckoutButton.propTypes = {
  isReseller: bool,
  isAdminWithoutCreditCard: bool,
  currentInvalidSubscription: oneOfType([string, bool]),
  cartId: string,
  size: string,
  kind: string,
  fullWidth: bool,
  disabled: bool,
  isLoading: bool,
}

export default connect(mapStateToProps)(CheckoutButton)
